// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function sanluismxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#sanluismxtext').show()
}

export function sanluismxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#sanluismxtext').hide()
}

export function guanamxdot_mouseIn_1(event) {
	//Add your code for this event here: 
	$w('#guanamxtext1').show()
}

export function guanamxdot_mouseOut_1(event) {
	//Add your code for this event here: 
	$w('#guanamxtext1').hide()
}



export function cdmmxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#cdmmxtext').show()
}

export function cdmmxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#cdmmxtext').hide()
}

export function hidmxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#hidmxtext').show()
}

export function hidmxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#hidmxtext').hide()
}

export function michomxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#michomxtext').show()
}

export function michomxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#michomxtext').hide()
}

export function puemxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#puemxtext').show()
}

export function puemxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#puemxtext').hide()
}

export function veramxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#veramxtext').show()
}

export function veramxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#veramxtext').hide()
}

export function oaxmxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#oaxmxtext').show()
}

export function oaxmxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#oaxmxtext').hide()
}

export function tabmxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#tabmxtext').show()
}

export function tabmxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#tabmxtext').hide()
}

export function chiamxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#chiamxtext').show()
}

export function chiamxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#chiamxtext').hide()
}

export function campmxdot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#campmxtext').show()
}

export function campmxdot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#campmxtext').hide()
}

export function sanmarcosguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#sanmarcosguatetext').show()
}

export function sanmarcosguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#sanmarcosguatetext').hide()
}

export function cdgguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#cdgguatetext').show()
}

export function cdgguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#cdgguatetext').hide()
}

export function chimaguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#chimaguatetext').show()
}

export function chimaguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#chimaguatetext').hide()
}

export function hueguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#hueguatetext').show()
}

export function hueguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#hueguatetext').hide()
}

export function quetzaguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#quetzaguatetext').show()
}

export function quetzaguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#quetzaguatetext').hide()
}

export function quicheguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#quicheguatetext').show()
}

export function quicheguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#quicheguatetext').hide()
}

export function managuanicadot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#managuanicatext').show()
}

export function managuanicadot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#managuanicatext').hide()
}

export function chinicaraguadot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#chinicaraguatext').show()
}

export function chinicaraguadot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#chinicaraguatext').hide()
}

export function sansalsaldot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#sansalsaltext').show()
}

export function sansalsaldot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#sansalsaltext').hide()
}

export function sanmisaldot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#sanmisaltext').show()
}

export function sanmisaldot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#sanmisaltext').hide()
}

export function zacapaguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#zacapaguatetext').show()
}

export function zacapaguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#zacapaguatetext').hide()
}

export function ptobarriosguatedot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#ptobarriosguatetext').show()
}

export function ptobarriosguatedot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#ptobarriosguatetext').hide()
}

export function teguhondot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#teguhontext').show()
}

export function teguhondot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#teguhontext').hide()
}

export function corteshondot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#corteshontext').show()
}

export function corteshondot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#corteshontext').hide()
}

export function cholutecahondot_mouseIn(event) {
	//Add your code for this event here: 
	$w('#cholutecahontext').show()
}

export function cholutecahondot_mouseOut(event) {
	//Add your code for this event here: 
	$w('#cholutecahontext').hide()
}